<i18n>
{
  "pe": {
    "create-broker": "Agregar Broker"

  },
  "cl": {
     "create-broker": "Agregar Broker"

  },
  "br": {
    "create-broker": "Adicionar Broker"
  }
}
</i18n>
<template>
  <b-button
    :label="$t('create-broker')"
    type="is-primary"
    icon-left="fa-solid fa-user-plus"
    rounded
    class="is-button-secondary is-fullwidth-mobile"
    @click="cardModal">
    />
  </b-button>
</template>

<script>
import CreateBrokerForm from './formsFormat/CreateBrokerForm.vue';

export default {
  name: 'CreateBrokerButton',
  methods: {
    close() {
      this.$router.go(0);
      this.$emit('close');
    },
    imageModal() {
      const h = this.$createElement;
      const vnode = h('p', { class: 'image is-4by3' }, [
        h('img', { attrs: { src: 'https://buefy.org/static/img/placeholder-1280x960.png' } })
      ]);
      this.$buefy.modal.open({
        content: [vnode]
      });
    },
    cardModal() {
      this.$buefy.modal.open({
        onCancel: this.close,
        parent: this,
        component: CreateBrokerForm,
        hasModalCard: true,
        customClass: 'custom-class custom-class-2',
        trapFocus: true
      });
    }
  }
};
</script>
